import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { LogoMark } from "@/components/Logo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found | Ody Luxurious Spa" description="The page you are looking for has drifted away. Explore our services instead." />
      <section className="min-h-[80vh] flex items-center justify-center px-5 pt-20">
        <div className="text-center">
          <LogoMark size={72} className="mx-auto float-slow" />
          <h1 className="mt-8 font-serif font-light text-5xl sm:text-6xl text-ink">
            Lost in <span className="italic text-bronze">tranquility</span>
          </h1>
          <p className="mt-5 text-stone2 max-w-md mx-auto text-sm sm:text-base">
            This page seems to have drifted away. Let us guide you back to calm.
          </p>
          <Link
            to="/"
            data-testid="notfound-home-btn"
            className="mt-9 inline-flex items-center gap-3 rounded-full bg-ink text-cream px-8 py-4 text-xs uppercase tracking-[0.2em] transition-colors duration-300 hover:bg-bronze"
          >
            Back to Home
          </Link>
        </div>
      </section>
    </>
  );
}
